<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
      color="blue darken-3"
      text="white"
      dark
    >
      <v-list dense>
        <v-list-item link @click="$vuetify.goTo('#about-me')">
          <v-list-item-action>
            <v-icon>mdi-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>About Ken</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$vuetify.goTo('#experience')">
          <v-list-item-action>
            <v-icon>mdi-pillar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Experience</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$vuetify.goTo('#pillars')">
          <v-list-item-action>
            <v-icon>mdi-pillar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Pillars of Leadership</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$vuetify.goTo('#calendar')">
          <v-list-item-action>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Events</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$vuetify.goTo('#faq')">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>FAQ</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$vuetify.goTo('#photos')">
          <v-list-item-action>
            <v-icon>mdi-pillar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Our Family</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link @click="$vuetify.goTo('#contact')">
          <v-list-item-action>
            <v-icon>mdi-email-open-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Contact Me</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar clipped-left app color="dark_primary" elevate-on-scroll elevation="20" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
<!--       <div class="d-flex align-center">
        <v-img alt="Vuetify Logo" class="shrink mr-2" contain src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png" transition="scale-transition" width="40" />

        
      </div> -->
      <v-toolbar-title class="text-h5 white--text font-weight-medium display-1"><span class=" app-bar-text">Vote for Ken Carr!</span></v-toolbar-title>
      <v-spacer></v-spacer>

    </v-app-bar>
    <HelloWorld/>
  </v-app>
</template>
<style lang="scss" scoped>

</style>

<script>
import HelloWorld from './components/HelloWorld';

export default {
  name: 'App',

  components: {
    HelloWorld,
  },
  data: () => ({
    bg: "primary",
    drawer: false
  }),
};
</script>
